import React from 'react';
import './App.css';

function Founders({ founders }) {
    if (!founders || founders.length === 0) {
        return (
            <div className="founders-page">
                <div className="founders-hero">
                    <h1 className="founders-heading">Founders</h1>
                </div>
                <div className="container" style={{ textAlign: 'center', color: '#fff' }}>
            
                </div>
            </div>
        );
    }

    return (
        <div className="founders-page">
            <div className="founders-hero">
                <h1 className="founders-heading">FOUNDERS</h1>
            </div>

            <div className="container">
                {founders.map((founder, index) => (
                    <div key={founder.id} className={`founder-row ${index % 2 !== 0 ? 'reversed' : ''}`}>

                        {/* Main Image Column */}
                        <div className="founder-image-col">
                            <div className="founder-main-photo">
                                {founder.mainImage ? (
                                    <img src={founder.mainImage} alt={founder.name} />
                                ) : (
                                    <div className="photo-placeholder">No Photo</div>
                                )}
                            </div>

                            {/* Sub Photos Grid - In Image Column */}
                            {founder.subImages && founder.subImages.length > 0 && (
                                <div className="founder-sub-photos">
                                    {founder.subImages.map((img, idx) => (
                                        <div key={idx} className="sub-photo-item">
                                            <img src={img} alt={`${founder.name} extra ${idx + 1}`} />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Content Column */}
                        <div className="founder-content-col">
                            <h2 className="founder-name">{founder.name}</h2>
                            <h3 className="founder-title">{founder.designation}</h3>
                            <p className="founder-biography">{founder.description}</p>
                        </div>

                    </div>
                ))}
            </div>
        </div>
    );
}

export default Founders;
